import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { RoleDetail } from '@/types/settings';

export function useCloneRole() {
  const queryClient = useQueryClient();

  return useApiMutation<RoleDetail, string>({
    mutationFn: (roleId) =>
      apiPost<RoleDetail>(operationsClient, settingsEndpoints.roleClone(roleId)),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: settingsKeys.roles() });
      toast.success('Role cloned');
    },
  });
}
